export var upiDetailsMapper = function (data) {
    var result = [];
    if (data && data.length > 0) {
        result = data.map(function (item) {
            return {
                Id: item.id,
                AcCode: item.acCode,
                UPI: item.upi,
                BankAcNo: item.bankAcNo,
                BankName: item.bankName,
                Source: item.source,
                CreatedBy: item.createdBy,
                CreatedDate: item.createdDate,
                ModifyBy: item.modifyBy,
                ModifyDate: item.modifyDate,
            };
        });
    }
    return result;
};
